import { URLConstructor } from '../utils/URLBuilder'
import { isStringNotEmpty } from '../utils/GlobalFunctions'
import { getQueryParam } from '../utils/LocationUtils'
import { EMPTY_STRING } from './Common'
import { APIElements } from './ApiConstants'
import { SLASH } from './Separators'

export const SERVLET_COMMAND = 'ServletCmd'
export const ORIGINAL_COMMAND: string = 'tbOriginalServletCmd'
export const REVERSION_SERVLET_COMMAND: string = 'tbReversionServletCmd'
export const APP_PATH = 'App'

// Internal properties included query parameter name.
export const INTERNAL_PROPS = 'IncludeInternalProps'
// Binned reports included query parameter name.
export const BINNED_REPORTS = 'IncludeBinnedReports'

/**
 * Servlet commands.
 */
export enum ServletCmds {
    ADMIN_AGENTS = 'CMD_ADMIN_ACDAGENTS',
    ADMIN_DIRECTORY = 'CMD_ADMIN_DIRECTORY',
    ADMIN_DEVICES = 'CMD_ADMIN_DEVICES',
    ADMIN_CODES = 'CMD_ADMIN_CODES',
    ADMIN_CMENVIRONMENTS = 'CMD_ADMIN_CMENVIRONMENTS',
    ADMIN_PARTITIONS = 'CMD_ADMIN_PARTITIONS',
    ADMIN_TELSYSS = 'CMD_ADMIN_TELSYSS',
    ADMIN_USERS = 'CMD_ADMIN_USERS',
    ADMIN_OCHINTS = 'CMD_ADMIN_OMNICHANNELINTEGRATION',
    ADMIN_CALLRECINTS = 'CMD_ADMIN_CALLRECINTEGRATIONS',
    ADMIN_MESSAGES = 'CMD_ADMIN_MESSAGES',
    ADMIN_DATABASE = 'CMD_ADMIN_DATABASE',
    ADMIN_LOGGING = 'CMD_ADMIN_LOGGING',
    LICENSEMGR = 'CMD_LICENSEMGR',
    LOGFILEMGR = 'CMD_LOGFILEMGR',
    AUDITTRAIL = 'CMD_AUDIT_TRAIL',
    TELMODULE_STATUS = 'CMD_TELMODULE_STATUS',
    OMNICHANNELMODULE_STATUS = 'CMD_OMNICHANNELMODULE_STATUS',
    TELMODULE_CALLCTRL = 'CMD_TELMODULE_CALLCTRL',
    APP_STATUS = 'CMD_APP_STATUS',
    RPT_LIST = 'CMD_RPT_LIST',
    RPT_CHANGE = 'CMD_RPT_CHANGE',
    RPT_TYPEDEFS = 'CMD_RPT_TYPEDEFS',
    RPT_FILTERENTITYINFO = 'CMD_RPT_FILTERENTITYINFO',
    RPT_STATINFO = 'CMD_RPT_STATINFO',
    RPT_PORTAL = 'CMD_RPT_PORTAL',
    MAIN_HOME = 'CMD_MAIN',
    BULK_ADD_USERS = 'CMD_BULK_ADD_USERS',
    RPT_FOLDER = 'CMD_RPT_FOLDER',
    COOKIE_POLICY = 'CMD_COOKIEPOLICY',
    AUTHENTICATION = 'CMD_AUTHENTICATE',
    MFA_SUCCESS = 'CMD_MFA_SUCCESS',
    BROADWORKS_SSO_FORWARD = 'CMD_BROADWORKS_SSO_FORWARD',
    PASSWORD_CHANGE_SUCCESS = 'CMD_PWD_SUCCESS',
    CMD_PASSWORDRESET = 'CMD_PASSWORDRESET',
    // Used by getServletCmdFromString function.
    MFA_LOGIN = 'CMD_MFA_LOGIN',
    TEAMS_AUTH = 'CMD_TEAMS_AUTH',
    INSIGHTS_HUB = 'CMD_INSIGHTS_HUB',
    TERMS_AND_CONDITIONS = 'CMD_TERMSOFSERVICE',
    SET_LANGUAGE = 'CMD_SETLANGUAGE',
    PRESENCE = 'CMD_TEAMS_PRESENCE'
}

export const getServletCmdFromString = (command: string): ServletCmds =>
    (ServletCmds as { [key: string]: ServletCmds })[command] ?? ServletCmds.MAIN_HOME

export const redirectToServlet = (
    command: ServletCmds,
    queryParams?: Record<string, Definable<string | number | string[]>>,
    originalCommand?: ServletCmds
): void => {
    const newServletURL: URLConstructor = URLConstructor.newInstance()
        .appendPathParams(location.pathname.replace(/(\/CCS\/App\/v2\/(.*)\/.*)/g, '/CCS/App/$2'))
        .appendQueryParams({
            [SERVLET_COMMAND]: command,
            ...(isStringNotEmpty(originalCommand) ? { [ORIGINAL_COMMAND]: originalCommand } : {}),
            ...queryParams
        })

    window.location.href = newServletURL.constructURL()
}

export const redirectToServletWithBranding = (
    command: string,
    brandingURL: string,
    queryParams?: Record<string, Definable<string | number | string[]>>,
    originalCommand?: ServletCmds,
    inNewTab?: boolean
): void => {
    const newServletURL: URLConstructor = URLConstructor.newInstance()
        .appendPathParams(APIElements.CCS, APIElements.API_APP, brandingURL.replace(SLASH, EMPTY_STRING))
        .appendQueryParams({
            [SERVLET_COMMAND]: command,
            ...(isStringNotEmpty(originalCommand) ? { [ORIGINAL_COMMAND]: originalCommand } : {}),
            ...queryParams
        })

    if (inNewTab) {
        window.open(newServletURL.constructURL(), '_blank')
        return
    }

    window.location.href = newServletURL.constructURL()
}

export const getOriginalCommandFromURL = (): ServletCmds =>
    getServletCmdFromString(getQueryParam(ORIGINAL_COMMAND)?.replace('CMD_', EMPTY_STRING) ?? EMPTY_STRING)
